<template>
  <div id="centered-container">
    <md-content class="md-elevation-3">
      <div class="title">
        <img src="/static/logo_azul.png" style="height: 30px" />
      </div>

      <template v-if="companies.length">
        <span>Selecione uma empresa para continuar</span>
        <div class="row">
          <div class="col-md-12 companies">
            <ul>
              <li
                v-for="(c, index) in companies"
                :key="index"
                class="mt-2"
                @click="doLoginCompany(c.uuid)"
              >
                <b>{{ c.applicationName }} - </b> {{ c.name }} -
                {{ c.identification }}
              </li>
            </ul>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="form">
          <md-field>
            <label>E-mail</label>
            <md-input v-model="login.email" autofocus />
          </md-field>

          <md-field md-has-password>
            <label>Senha</label>
            <md-input
              v-model="login.password"
              type="password"
              @keyup.enter="trigger"
            />
          </md-field>
        </div>

        <div class="actions md-layout md-alignment-center-space-between">
          <router-link to="/forgot-password"
            ><a>Esqueceu a senha?</a></router-link
          >
          <md-button
            v-if="!login.email || !login.password"
            class="md-raised md-primary"
            disabled
            @click="doLogin()"
            >Acessar</md-button
          >
          <md-button
            v-else=""
            ref="sendReply"
            class="md-raised md-primary"
            @click="doLogin()"
            >Acessar</md-button
          >
        </div>

        <div v-if="loading" class="loading-overlay">
          <md-progress-spinner :md-stroke="2" md-mode="indeterminate" />
        </div>
      </template>
    </md-content>

    <div class="app-footer wrapper-sm">
      <div class="row pos-rlt text-center">
        <div class="div-img-footer"></div>
        <div class="col-md-12">
          <nav class="link-list list-inline-ui m-b-none pull-left w-full" />
          <small class="app-footer-copy m-t-xs pull-left w-full">
            Copyright © {{ dateAtual }} Zucchetti. Todos os direitos reservados
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { httpLoginV2, http, httpV2 } from "../api/backend";
import { ACCOUNTANT } from "../api/planAccountConst";

export default {
  name: "Login",
  components: {
    moment
  },
  data() {
    return {
      loading: false,
      companies: [],
      login: {
        email: "",
        password: ""
      },
      dateAtual: moment().format("YYYY")
    };
  },
  methods: {
    async doLoginCompany(uuid) {
      try {
        this.loading = true;

        const { data } = await httpV2.post("auth.token", {
          grant_type:
            "urn:zucchetti:params:oauth:grant-type:company-token-exchange",
          client_id: "my-invoices",
          company_uuid: uuid,
          subject_token: localStorage.getItem("access_token")
        });

        localStorage.setItem("access_token", data.access_token);
        localStorage.setItem("token_type", data.token_type);

        this.loading = false;

        this.checkCurrenPlan();
      } catch (error) {
        this.$toasted.show("Dados de login incorretos, verifique.", {
          theme: "outline",
          position: "bottom-right",
          duration: 5000,
          type: "error",
          icon: "error_outline"
        });
        this.loading = false;
        this.companies = [];
      }
    },
    doLogin() {
      this.loading = true;
      setTimeout(() => {
        httpLoginV2
          .post("auth.token", {
            grant_type: "password",
            client_id: "my-invoices",
            username: this.login.email,
            password: this.login.password,
            options: { isSharedAccess: true }
          })
          .then(response => {
            localStorage.setItem("access_token", response.data.access_token);
            localStorage.setItem("token_type", response.data.token_type);

            if (response.data.subscription_status == 402) {
              return this.$router.push({ name: "customException" });
            }

            if (!response.data.companies) {
              this.checkCurrenPlan();
              return;
            }

            if (response.data.companies) {
              this.companies = response.data.companies;
            }
          })
          .catch(error => {
            const { data } = error.response;

            if (
              data.error_message.startsWith(
                "Nenhuma aceitação de termos de uso foi localizado para este CNPJ"
              )
            ) {
              this.$router.push({ path: "/terms-acceptance" });
              return;
            }

            const invalidLoginMessage =
              data.error_message === "E-mail inválido";
            const invalidPasswordMessage =
              data.error_message === "Senha inválida";

            const invalidLoginCode = data.error_code === 422;

            if (
              invalidLoginMessage ||
              invalidLoginCode ||
              invalidPasswordMessage
            ) {
              this.$toasted.show("Dados de login incorretos, verifique.", {
                theme: "outline",
                position: "bottom-right",
                duration: 5000,
                type: "error",
                icon: "error_outline"
              });
              this.loading = false;
              return;
            }

            this.$router.push({ name: "invalidDocument" });
          });
      }, 1000);
    },

    checkCurrenPlan() {
      http
        .post("application.get-current_subscription")
        .then(response => {
          if (response.data.paymentMode.id === ACCOUNTANT) {
            this.loading = false;
            this.$router.push({ path: "/accountant/requests" });
            return;
          }
          this.loading = false;
          this.$router.push({ path: "/dashboard" });
        })
        .catch(() => {
          this.$toasted.show(
            "Falha ao tentar identificar seu Plano, entre em contato.",
            {
              theme: "outline",
              position: "bottom-right",
              duration: 5000,
              type: "error",
              icon: "error_outline"
            }
          );
          this.loading = false;
        });
    },

    trigger() {
      this.doLogin();
    }
  }
};
</script>

<style type="text/css">
#centered-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;
}
.title {
  text-align: center;
  margin-bottom: 30px;
  color: #1b8af1;
  font-size: 34px;
  font-weight: 300;
}

.form {
  margin-bottom: 60px;
}

.md-elevation-3 {
  z-index: 1;
  padding: 40px;
  width: 100%;
  max-width: 400px;
  position: relative;
  border-radius: 5px;
  border: 1px solid transparent;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  transition: all 0.5s;
  margin: 40px;
}

.card {
  border-radius: 5px;
  border: 1px solid transparent;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  transition: all 0.5s;
}

.loading-overlay {
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
}

.button-success {
  color: #fff;
  background-color: #44bb52;
  border-color: rgba(0, 0, 0, 0);
}

.companies li {
  list-style-type: none;
  border: 1px solid #7e7e7e;
  padding: 5px;
  border-radius: calc(0.625rem - 1px);
  cursor: pointer !important;
  padding-left: 1rem;
}

.companies li:hover {
  border-left: 4px solid #1b8af1;
}

.companies ul {
  padding-left: 0;
}

.companies .icon-access {
  position: absolute;
  right: 3rem !important;
  margin-top: -0.5rem !important;
}
</style>



// WEBPACK FOOTER //
// src/public/login/Login.vue